/**
 * Smooth Scroll Polyfill
 * Provides scroll-behavior: smooth support for browsers that don't natively support it (mainly Safari)
 * This polyfill uses requestAnimationFrame for smooth animations and is non-blocking
 */

(function() {
  // Check if the browser supports scroll-behavior: smooth
  function supportsScrollBehavior() {
    const element = document.documentElement;
    const originalStyle = element.style.scrollBehavior;
    element.style.scrollBehavior = 'smooth';
    const isSupported = window.getComputedStyle(element).scrollBehavior === 'smooth';
    element.style.scrollBehavior = originalStyle;
    return isSupported;
  }

  // If the browser already supports scroll-behavior, don't load the polyfill
  if (supportsScrollBehavior()) {
    return;
  }

  // Easing function for smooth animation
  function easeInOutQuad(t) {
    return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
  }

  // Smooth scroll implementation
  function smoothScroll(element, target, duration = 1000) {
    const start = element[element === document.documentElement ? 'scrollTop' : 'scrollLeft'];
    const targetValue = typeof target === 'number' ? target : target;
    const distance = targetValue - start;
    const startTime = performance.now();

    function animate(currentTime) {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const ease = easeInOutQuad(progress);

      element.scrollTop = start + distance * ease;

      if (progress < 1) {
        requestAnimationFrame(animate);
      }
    }

    requestAnimationFrame(animate);
  }

  // Override window.scrollTo
  const originalScrollTo = window.scrollTo;
  window.scrollTo = function(x, y) {
    let options = {};
    
    // Handle different argument types
    if (typeof x === 'object') {
      options = x;
    } else {
      options.left = x;
      options.top = y;
    }

    // If not smooth, use native scroll
    if (options.behavior !== 'smooth') {
      return originalScrollTo.call(window, options.left || 0, options.top || 0);
    }

    // Smooth scroll
    smoothScroll(document.documentElement, options.top || 0);
  };

  // Handle scroll-behavior on anchor links
  document.addEventListener('click', function(e) {
    const link = e.target.closest('a[href^="#"]');
    if (!link || link.href === window.location.href.split('#')[0] + '#') {
      return;
    }

    const targetId = link.getAttribute('href').substring(1);
    const targetElement = document.getElementById(targetId);

    if (targetElement) {
      e.preventDefault();
      const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY;
      smoothScroll(document.documentElement, targetPosition);
      
      // Update URL without page jump
      history.pushState(null, null, '#' + targetId);
    }
  }, false);

  // Also support Element.prototype.scrollIntoView with smooth behavior
  const originalScrollIntoView = Element.prototype.scrollIntoView;
  Element.prototype.scrollIntoView = function(options) {
    if (!options || options.behavior !== 'smooth') {
      return originalScrollIntoView.call(this, options);
    }

    const targetPosition = this.getBoundingClientRect().top + window.scrollY;
    smoothScroll(document.documentElement, targetPosition);
  };
})();
